import React, { Fragment, useEffect } from 'react';
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Header from "../wrappers/header/Header";
import Footer from "../wrappers/footer/Footer";

const LayoutMain = (props) => {
  const {
    children,
    headerContainerClass,
    headerPaddingClass,
    headerPositionClass,
    containerStyle,
    ...otherProps
  } = props;
  
  // Redux에서 withcookieData 가져오기
  const withcookieData = useSelector(state => state.withcookie?.withcookieData);
  
  // 테마 및 메타데이터 추출
  const theme = withcookieData?.skin?.theme || {};
  const skin = withcookieData?.skin || {};
  
  // 색상 데이터 추출
  const colorSet = theme?.colorset || {};
  const primaryColor = colorSet?.primary || "#14005c";
  const secondaryColor = colorSet?.secondary || "#4CAF50";
  const dangerColor = colorSet?.danger || "#F5313F";
  
  // 동적 스타일 생성 - 추출한 색상으로 CSS 변수 설정
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--primary-color', primaryColor);
    root.style.setProperty('--secondary-color', secondaryColor);
    root.style.setProperty('--danger-color', dangerColor);
  }, [primaryColor, secondaryColor, dangerColor]);
  
  return (
    <Fragment>
      <div id="appCapsule" style={containerStyle || {}}>
        <Header
          withcookieData={withcookieData}
          headerContainerClass={headerContainerClass}
          headerPaddingClass={headerPaddingClass}
          headerPositionClass={headerPositionClass}
          {...otherProps}
        />
        {children}
        <Footer
          withcookieData={withcookieData}
        />
      </div>
    </Fragment>
  );
};

LayoutMain.propTypes = {
  children: PropTypes.node,
  headerContainerClass: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  headerPositionClass: PropTypes.string,
  containerStyle: PropTypes.object
};

export default LayoutMain; 